document.addEventListener("DOMContentLoaded", function () {
  // Function to create and insert the button
  function createAndInsertButton() {
    var defaultButton = document.querySelector(
      ".address-btn > .cf-edit-account-link"
    );
    defaultButton.style.cssText = "display: none;";

    var button = document.createElement("a");
    button.href = "/a/edit-profile";
    button.innerHTML = "EDIT PROFILE";
    button.className = "cf-edit-account-link";
    button.style.cssText =
      "display: block; text-decoration: underline; margin-bottom: 10px; margin-top: -10px; font-weight: bold;";

    var mainContent = document.querySelector(".yotpo-logged-in-view");
    if (mainContent) {
      mainContent.insertBefore(button, mainContent.lastChild);
    }
  }

  var interval = setInterval(function () {
    console.log("checking if app scripts are loaded");
    if (document.querySelector(".yotpo-logged-in-view")) {
      console.log("app scripts are loaded");
      createAndInsertButton();
      clearInterval(interval);
    }
  }, 1000);
});
